import Swiper from "swiper/bundle";

export default () => {
  const childrenSlider = new Swiper(".children-slider", {
    loop: true,
    speed: 10000,
    allowTouchMove: false,
    spaceBetween: 10,
    autoplay: {
      delay: 0,
    },
    slidesPerView: 3,
    breakpoints: {
      640: {
        slidesPerView: 5,
      },
    },
  });
};
